module.exports = __webpack_public_path__ + "img/0.5a4915ee.png";